<div class="modal-header">
  <h5 class="modal-title" i18n>Rename Document</h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>

<div class="modal-body">
  <form [formGroup]="form">
    <mat-form-field2 class="mat-block">
      <input matInput type="text" formControlName="name" i18n-placeholder placeholder="Name" [required]="true" />
    </mat-form-field2>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="close()" i18n>Cancel</button>

  <button type="button" class="btn btn-secondary-info" (click)="onSave(form)">
    <i class="fas fa-save"></i> <ng-container i18n>Save</ng-container>
  </button>
</div>
